import "./App.scss";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
import Index from "./pages/index";
function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/" component={Index} exact={true} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
